interface TaxPayerAssets {
  id?: number;
  taxPayerId?: number;
  signaturePath?: string | null;
  signaturePassword?: string | null;
  signatureExpirationDate?: string | null;
  logoPath?: string | null;
  emailInvoiceTemplatePath?: string | null;
  emailCreditNoteTemplatePath?: string | null;
  emailDebitNoteTemplatePath?: string | null;
  emailRemissionNoteTemplatePath?: string | null;
  emailCancellationTemplatePath?: string | null;
  emailReceiptTemplatePath?: string | null;
  invoiceKudeHtmlTemplatePath?: string | null;
  creditNoteKudeHtmlTemplatePath?: string | null;
  debitNoteKudeHtmlTemplatePath?: string | null;
  remissionNoteKudeHtmlTemplatePath?: string | null;
  autoInvoiceKudeTemplatePath?: string | null;
  receiptHtmlTemplatePath?: string | null;
}

export type TemplateField =
  | "emailInvoiceTemplatePath"
  | "emailCreditNoteTemplatePath"
  | "emailDebitNoteTemplatePath"
  | "emailRemissionNoteTemplatePath"
  | "emailCancellationTemplatePath"
  | "emailReceiptTemplatePath"
  | "invoiceKudeHtmlTemplatePath"
  | "creditNoteKudeHtmlTemplatePath"
  | "debitNoteKudeHtmlTemplatePath"
  | "remissionNoteKudeHtmlTemplatePath"
  | "autoInvoiceKudeTemplatePath"
  | "receiptHtmlTemplatePath";

export const EMAIL_TEMPLATE_FIELDS: { field: TemplateField; label: string }[] =
  [
    { field: "emailInvoiceTemplatePath", label: "Factura" },
    { field: "emailCreditNoteTemplatePath", label: "Nota de Crédito" },
    { field: "emailDebitNoteTemplatePath", label: "Nota de Débito" },
    { field: "emailRemissionNoteTemplatePath", label: "Nota de Remisión" },
    { field: "emailCancellationTemplatePath", label: "Cancelación" },
    { field: "emailReceiptTemplatePath", label: "Recibo" },
  ];

export const KUDE_TEMPLATE_FIELDS: { field: TemplateField; label: string }[] = [
  { field: "invoiceKudeHtmlTemplatePath", label: "Factura" },
  { field: "creditNoteKudeHtmlTemplatePath", label: "Nota de Crédito" },
  { field: "debitNoteKudeHtmlTemplatePath", label: "Nota de Débito" },
  { field: "remissionNoteKudeHtmlTemplatePath", label: "Nota de Remisión" },
  { field: "autoInvoiceKudeTemplatePath", label: "Autofactura" },
  { field: "receiptHtmlTemplatePath", label: "Recibo" },
];

export default TaxPayerAssets;
